import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const serviceMyPackageAvailable = {
  async get(userId: number, categoryId: number, packageId: number): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.get(
        process.env.API_MY_PACKAGE_AVAILABLE
          .replace(':userId', String(userId))
          .replace(':categoryId', String(categoryId))
          .replace(':packageId', String(packageId)),
          config
      );
      if (data.error) {
        throw new Error();
      }
      return data;
    } catch (e) {
      console.log('Error from services', e);
      throw new Error(e);
    }
  }
}